var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"a-label"},[_vm._t("default"),(_vm.required)?_c('sup',{class:_vm.labelRequired},[_vm._v("*")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }